/* eslint-disable max-len */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Tools from '../assets/landing/tools.svg';
import StepByStep from '../assets/landing/step-by-step.svg';
import SampleSurvey from '../assets/landing/sample-survey.svg';
import UserTestimonials from '../assets/landing/user-testimonials.svg';
import Footer from '../components/Footer';
import {
  openModal, setResetPassParams, speak,
} from '../actions';

class LandingPage extends Component {
  componentDidMount() {
    if (this.props.resetPassword) {
      this.props.openModal('ResetPass');
      this.props.setResetPassParams(this.props.match.params.hash, this.props.match.params.email);
    }
  }

  render() {
    return (
      <div className="landing-container">
        <div className="main-landing-container">
          <button className="main-landing-button cta-button"
            type="button"
            onClick={() => {
              if (!this.props.auth) {
                this.props.openModal('OneMore');
              } else {
                this.props.history.push('/dashboard');
              }
            }}
          >
            Start a Toolkit
          </button>
        </div>
        <div className="landing-subcontainer">
          <h2 className={`${this.props.speechEnabled ? 'bolded' : null}`} onClick={this.props.speak}>My Brain Explained personalizes a variety of Toolkits based on how your brain thinks and learns.</h2>
          <div>
            <img src={Tools} alt="tools" />
            <p className={`${this.props.speechEnabled ? 'bolded' : null}`} onClick={this.props.speak}>
              It seems obvious that you should understand how your <b>brain</b> works, but most people don’t.
              It’s not taught in school or at work. We use <b>neuroscience, cognitive science,</b> and <b>behavioral psychology</b> to provide intelligent solutions to help you <b>reach your potential</b>.
            </p>
          </div>
        </div>
        <div className="step-by-step-container">
          <img className="step-by-step-image" src={StepByStep} alt="step-by-step" />
        </div>
        <div className="blue-banner">
          <p className={`${this.props.speechEnabled ? 'bolded' : null}`} onClick={this.props.speak}>Take a peek at the Toolkit Builder:</p>
        </div>
        <div className="sample-survey-container">
          <img src={SampleSurvey} alt="sample-survey" />
        </div>
        <div className="user-testimonials-container">
          <img src={UserTestimonials} alt="user-testimonials" />
          <button className="cta-button"
            type="button"
            onClick={() => {
              if (!this.props.auth) {
                this.props.openModal('OneMore');
              } else {
                this.props.history.push('/dashboard');
              }
            }}
          >Start a Toolkit
          </button>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => (
  {
    auth: state.user.authenticated,
    speaker: state.speech.speaker,
    speechEnabled: state.speech.enabled,
  }
);

export default connect(mapStateToProps, {
  openModal, setResetPassParams, speak,
})(withRouter(LandingPage));
